import IMfilesValueListItem from "../interfaces/mfiles/IMfilesValueListItem";
import { AxiosInstance } from "axios";
import { fetchValueListItemsUrl, fetchObjectsByQuickQueryUrl, fetchObjectsByQuickQueryFilteredUrl } from "../helpers/urlHelper";
import { IMfilesObject } from "../interfaces/mfiles/IMFilesObject";
import { IMFilesResult } from "../interfaces/mfiles/IMFilesResult";
import { IMfilesPropertyFilter, IValueListFilter } from "../interfaces/filters/IFilter";

export const getValueListItemsAsync = async (httpClient: AxiosInstance, valueListId: number): Promise<IMfilesValueListItem[]> => {
  const url = fetchValueListItemsUrl(valueListId);
  const result = await httpClient.get<IMFilesResult<IMfilesValueListItem>>(url);
  return result.data.Items;
};

export const getLookupItemsAsync = async (
  httpClient: AxiosInstance,
  objectTypeId: number,
  searchTerm: string,
  limit: number
): Promise<IMfilesObject[]> => {
  const url = fetchObjectsByQuickQueryUrl(objectTypeId, searchTerm, limit);
  const result = await httpClient.get<IMFilesResult<IMfilesObject>>(url);
  return result.data.Items;
};

export const getLookupItemsFilteredAsync = async (
  httpClient: AxiosInstance,
  objectTypeId: number,
  searchTerm: string,
  propFilters: IMfilesPropertyFilter[],
  vlFilters: IValueListFilter[],
  limit: number
): Promise<IMfilesObject[]> => {
  
  const url    = fetchObjectsByQuickQueryFilteredUrl(objectTypeId, searchTerm, propFilters, vlFilters, limit);
  const result = await httpClient.get<IMFilesResult<IMfilesObject>>(url);

  return result.data.Items;
};
